
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9MIqa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5f6a50c1f249dcf5$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $cu6g7 = parcelRequire("cu6g7");

var $6ilbC = parcelRequire("6ilbC");

var $8tW4o = parcelRequire("8tW4o");

var $2QO3b = parcelRequire("2QO3b");

var $fzflF = parcelRequire("fzflF");
function $5f6a50c1f249dcf5$var$getParentStack(labelStack) {
    if (!labelStack || labelStack.length <= 1) return null;
    return labelStack.slice(0, labelStack.length - 1);
}
function $5f6a50c1f249dcf5$var$getSegmentId(labelStack) {
    if (!labelStack) return null;
    const leafLabelStack = labelStack[labelStack.length - 1];
    if ((0, $cu6g7.isSegmentLabel)(leafLabelStack)) return leafLabelStack.segmentId;
    const parentStack = $5f6a50c1f249dcf5$var$getParentStack(labelStack);
    if (!parentStack) return null;
    return $5f6a50c1f249dcf5$var$getSegmentId(parentStack);
}
function $5f6a50c1f249dcf5$var$getParentSegmentId(labelStack) {
    return $5f6a50c1f249dcf5$var$getSegmentId($5f6a50c1f249dcf5$var$getParentStack(labelStack));
}
/**
 * Whenever a render happen, all parent segment have timing reported
 * This method tries to reduce that noise
 */ function $5f6a50c1f249dcf5$var$removeCascadingParentTimingReport(reactProfilerTimings) {
    const timingIndex = new Map();
    reactProfilerTimings.forEach((timing)=>{
        const segmentId = $5f6a50c1f249dcf5$var$getSegmentId(timing.labelStack);
        if (segmentId) {
            const timingArray = timingIndex.get(segmentId) ?? [];
            timingIndex.set(segmentId, timingArray);
            timingArray.push(timing);
        }
    });
    reactProfilerTimings.forEach((timing)=>{
        const parentSegmentId = $5f6a50c1f249dcf5$var$getParentSegmentId(timing.labelStack);
        if (parentSegmentId) {
            const parentTimings = timingIndex.get(parentSegmentId);
            const filteredParentTimings = parentTimings?.filter((parentTiming)=>{
                return !(parentTiming.startTime === timing.startTime && parentTiming.actualDuration === timing.actualDuration);
            });
            if (filteredParentTimings) timingIndex.set(parentSegmentId, filteredParentTimings);
            else timingIndex.delete(parentSegmentId);
        }
    });
    return [
        ...timingIndex.values()
    ].flatMap((v)=>v);
}
function $5f6a50c1f249dcf5$var$transformReactProfilerTimings(reactProfilerTimings) {
    const filtered = $5f6a50c1f249dcf5$var$removeCascadingParentTimingReport(reactProfilerTimings ?? []);
    const reactProfilerTimingsMap = filtered.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && type !== 'nested-update') {
            const label = labelStack.map((ls)=>ls.name).join('/');
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const cacheKey = (0, $cu6g7.stringifyLabelStackFully)(labelStack);
            const timing = result.get(label) || {
                labelStack: label,
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 1,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = Math.round(start);
            if (end > timing.endTime) timing.endTime = Math.round(end);
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $2QO3b.segmentUnmountCache).has(cacheKey) && (0, $eGOwo.fg)('platform_ufo_segment_unmount_count')) {
                timing.unmountCount = (0, $2QO3b.segmentUnmountCache).get(cacheKey) || 0;
                (0, $2QO3b.segmentUnmountCache).delete(cacheKey);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
function $5f6a50c1f249dcf5$var$createPostInteractionLogPayload({ lastInteractionFinish: lastInteractionFinish, reactProfilerTimings: reactProfilerTimings, lastInteractionFinishVCResult: lastInteractionFinishVCResult, postInteractionFinishVCResult: postInteractionFinishVCResult }) {
    const config = (0, $jcIvM.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    if (!lastInteractionFinish) return null;
    const ufoName = (0, $cu6g7.sanitizeUfoName)(lastInteractionFinish.ufoName);
    const rate = (0, $jcIvM.getPostInteractionRate)(ufoName, lastInteractionFinish.type);
    if (!(0, $2oAAJ.default)(rate)) return null;
    const pageVisibilityState = (0, $8tW4o.getPageVisibilityState)(lastInteractionFinish.start, lastInteractionFinish.end);
    if (pageVisibilityState !== 'visible') return null;
    // Align post-interaction-logs closer to UFO event behaviour,
    // e.g. also check for aborted or failed events
    if (lastInteractionFinish.abortReason) return null;
    if (lastInteractionFinish.errors.length > 0) return null;
    const maxEndTimeFromProfiler = reactProfilerTimings && reactProfilerTimings.length > 0 ? Math.max(...reactProfilerTimings.map((t)=>t.commitTime)) : lastInteractionFinish.end;
    const revisedEndTime = Math.round(maxEndTimeFromProfiler);
    const revisedTtai = Math.round(maxEndTimeFromProfiler - lastInteractionFinish.start);
    const lastInteractionFinishStart = Math.round(lastInteractionFinish.start);
    const lastInteractionFinishEnd = Math.round(lastInteractionFinish.end);
    const lastInteractionFinishTTAI = Math.round(lastInteractionFinish.end - lastInteractionFinish.start);
    const mostRecentVCRevision = (0, $jcIvM.getMostRecentVCRevision)(lastInteractionFinish.ufoName) ?? (0, $jcIvM.DEFAULT_TTVC_REVISION);
    let lastInteractionFinishVC90 = null;
    let lastInteractionFinishVCClean = false;
    const lastInteractionFinishVCRev = lastInteractionFinishVCResult?.['ufo:vc:rev'];
    const lastInteractionFinishRevision = lastInteractionFinishVCRev?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (lastInteractionFinishRevision?.clean) {
        lastInteractionFinishVCClean = true;
        lastInteractionFinishVC90 = lastInteractionFinishRevision['metric:vc90'] ?? null;
    }
    let postInteractionFinishVCRatios = {};
    let postInteractionFinishVCClean = false;
    let revisedVC90 = null;
    let lateMutations = [];
    const postInteractionFinishVCRev = postInteractionFinishVCResult?.['ufo:vc:rev'];
    const postInteractionFinishRevision = postInteractionFinishVCRev?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (postInteractionFinishRevision?.clean) {
        postInteractionFinishVCClean = true;
        postInteractionFinishVCRatios = postInteractionFinishRevision.ratios;
        if (typeof lastInteractionFinishVC90 === 'number') revisedVC90 = postInteractionFinishRevision['metric:vc90'] ?? null;
        const vcDetails = postInteractionFinishRevision.vcDetails;
        const labelStacks = postInteractionFinishRevision.labelStacks;
        if (vcDetails) lateMutations = (0, $fzflF.default)(vcDetails, labelStacks, lastInteractionFinish, postInteractionFinishVCRatios);
    }
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6ilbC.getReactUFOPayloadVersion)(lastInteractionFinish.type, true)
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.post-interaction-logs',
                postInteractionLog: {
                    lastInteractionFinish: {
                        ...lastInteractionFinish,
                        ufoName: ufoName,
                        start: lastInteractionFinishStart,
                        end: lastInteractionFinishEnd,
                        ttai: lastInteractionFinishTTAI,
                        vc90: lastInteractionFinishVC90,
                        vcClean: lastInteractionFinishVCClean
                    },
                    revisedEndTime: revisedEndTime,
                    revisedTtai: revisedTtai,
                    revisedVC90: revisedVC90,
                    vcClean: postInteractionFinishVCClean,
                    lateMutations: lateMutations,
                    reactProfilerTimings: $5f6a50c1f249dcf5$var$transformReactProfilerTimings(reactProfilerTimings)
                }
            }
        }
    };
}
var $5f6a50c1f249dcf5$export$2e2bcd8739ae039 = $5f6a50c1f249dcf5$var$createPostInteractionLogPayload;

});
parcelRegister("fzflF", function(module, exports) {
$parcel$export(module.exports, "default", () => $96b810c8c520bdd6$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");
function $96b810c8c520bdd6$var$getLateMutations(vcDetails, labelStacks = {}, lastInteractionFinish, postInteractionFinishVCRatios) {
    // Map to track which elements are already seen for each timestamp
    const seen = new Map();
    const result = [];
    for(const part in vcDetails){
        const details = vcDetails[part];
        if (!details?.t || details.t <= lastInteractionFinish.end || !details.e) continue; // Skip if not late or no elements
        if (!seen.has(details.t)) seen.set(details.t, new Set());
        const seenElements = seen.get(details.t);
        for (const element of details.e){
            if (seenElements.has(element)) continue;
            seenElements.add(element);
            const lateMutation = {
                time: details.t,
                element: element,
                viewportHeatmapPercentage: postInteractionFinishVCRatios?.[element] || 0
            };
            if (labelStacks && (0, $eGOwo.fg)('platform_ufo_enable_late_mutation_label_stacks')) {
                const labels = labelStacks[element];
                if (labels) {
                    lateMutation.segment = labels.segment;
                    lateMutation.labelStack = labels.labelStack;
                }
            }
            result.push(lateMutation);
        }
    }
    return result;
}
var $96b810c8c520bdd6$export$2e2bcd8739ae039 = $96b810c8c520bdd6$var$getLateMutations;

});



//# sourceMappingURL=create-post-interaction-log-payload.2a34db26.js.map
